import React from 'react';
import {IHotelDetailsWithTerms} from 'gui/components/editors/hotelEditor/components/hotelDetailsForm';
import AdWebsite from '../adWebsite/AdWebsite';

interface IAdHotelWebsiteProps {
  hotelDetails: IHotelDetailsWithTerms
}

const AdHotelWebsite = (props: IAdHotelWebsiteProps) => (
  <AdWebsite
    label={"קישור למלון"}
    url={props.hotelDetails.hotel && props.hotelDetails.hotel.website}
  />
);

AdHotelWebsite.defaultProps = {
  hotelDetails: {
    hotel: {},
  },
};
export default AdHotelWebsite;
